module.exports = __webpack_public_path__ + "static/img/S03.9f41155.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/S03.jpg
// module id = f/x5
// module chunks = 9